import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag, Id, PermissionRule } from "PFTypes";

type UseBookingModulePermissionsReturn = {
  isEnabled: boolean;
  isPermittedToEdit: boolean;
  isPermittedToAccess: boolean;
  isBookingResourcer: boolean;
  canCreateEngagementBookings: boolean;
  canManagePublicActivityBookings: boolean;
  isAdmin: boolean;
  canProfileCreateBooking: (profileId?: Id) => boolean;
};

const useBookingModulePermissions = (): UseBookingModulePermissionsReturn => {
  const { data: currentProfile } = useCurrentProfile();

  const isPermittedTo = useIsCurrentUserPermittedTo();
  const isEnabled = useIsFeatureEnabled();
  const isBMEnabled = isEnabled(FeatureFlag.BookingModule);
  const isPermittedToEdit = isPermittedTo(PermissionRule.BookingResourcer);
  const isBookingResourcer = isPermittedTo(PermissionRule.BookingResourcer); // can manage demand, repeated, group bookings, as well as different users bookings
  const isPermittedToAccess = isPermittedTo(PermissionRule.BookingAccess);
  const canCreateEngagementBookings = isPermittedTo(PermissionRule.CreateEngagementBookings);
  const canManagePublicActivityBookings = isPermittedTo(PermissionRule.ManagePublicActivityBookings);

  const canProfileCreateBooking = (profileId?: Id) =>
    isBMEnabled && (isPermittedToEdit || (isPermittedToAccess && profileId === currentProfile.id));

  return {
    isEnabled: isBMEnabled,
    isPermittedToEdit,
    isPermittedToAccess,
    isBookingResourcer,
    canCreateEngagementBookings,
    canManagePublicActivityBookings,
    isAdmin: isPermittedTo(PermissionRule.BookingAdmin),
    canProfileCreateBooking
  };
};

export default useBookingModulePermissions;
